import { connect } from 'react-redux';
import { getDocumentsUrlInit,getUrlPdfContrat } from '../../../../../redux/selectors/init/init.selectors';
import EnvoiPieces from './EnvoiPieces';

const mapStateToProps = (state) => {
    return {
        documentsUrl: getDocumentsUrlInit(state),
        urlPdfContrat: getUrlPdfContrat(state),
    };
};

const EnvoiPiecesContainer = connect(mapStateToProps)(EnvoiPieces);

export default EnvoiPiecesContainer;
